import { useState } from 'react';
import { KeyRound, X } from 'lucide-react';

export default function PinChangeModal({ firstLogin = false, onComplete, onClose }) {
    const [oldPin, setOldPin] = useState('');
    const [newPin, setNewPin] = useState('');
    const [confirmPin, setConfirmPin] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        if (newPin.length < 4 || newPin.length > 8) {
            setError('PIN musí mít 4-8 číslic');
            return;
        }

        if (newPin !== confirmPin) {
            setError('PINy se neshodují');
            return;
        }

        setLoading(true);

        try {
            await fetch('/sanctum/csrf-cookie');
            const token = document.cookie
                .split('; ')
                .find(row => row.startsWith('XSRF-TOKEN='))
                ?.split('=')[1];

            const body = { novy_pin: newPin };
            if (!firstLogin) {
                body.stary_pin = oldPin;
            }

            const res = await fetch('/auth/pin', {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'X-XSRF-TOKEN': decodeURIComponent(token || ''),
                },
                body: JSON.stringify(body),
            });

            if (!res.ok) {
                const data = await res.json();
                setError(data.error || 'Chyba při změně PINu');
                setLoading(false);
                return;
            }

            onComplete();
        } catch {
            setError('Chyba při změně PINu');
        }
        setLoading(false);
    };

    const inputStyle = {
        width: '100%',
        padding: '12px 14px',
        borderRadius: '10px',
        border: '1px solid var(--border-default)',
        background: 'var(--surface-elevated)',
        color: 'var(--text-primary)',
        fontSize: '14px',
        outline: 'none',
        letterSpacing: '4px',
        boxSizing: 'border-box',
    };

    return (
        <div style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(0,0,0,0.6)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
            padding: '24px',
        }}>
            <div style={{
                background: 'var(--surface-raised)',
                border: '1px solid var(--border-default)',
                borderRadius: '16px',
                padding: '32px',
                width: '100%',
                maxWidth: '380px',
                boxShadow: 'var(--shadow-lg)',
            }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <KeyRound size={20} style={{ color: 'var(--brand)' }} />
                        <h3 style={{ margin: 0, fontSize: '16px', fontWeight: 600, color: 'var(--text-primary)' }}>
                            {firstLogin ? 'Nastavte si nový PIN' : 'Změna PINu'}
                        </h3>
                    </div>
                    {!firstLogin && (
                        <button
                            onClick={onClose}
                            style={{
                                background: 'none', border: 'none', cursor: 'pointer',
                                color: 'var(--text-muted)', padding: '4px',
                            }}
                        >
                            <X size={18} />
                        </button>
                    )}
                </div>

                {firstLogin && (
                    <p style={{ fontSize: '13px', color: 'var(--text-muted)', margin: '0 0 16px 0' }}>
                        Toto je vaše první přihlášení. Pro bezpečnost si prosím zvolte vlastní PIN.
                    </p>
                )}

                <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                    {!firstLogin && (
                        <input
                            type="password"
                            inputMode="numeric"
                            placeholder="Aktuální PIN"
                            value={oldPin}
                            onChange={e => setOldPin(e.target.value.replace(/\D/g, '').slice(0, 8))}
                            required
                            style={inputStyle}
                        />
                    )}
                    <input
                        type="password"
                        inputMode="numeric"
                        placeholder="Nový PIN (4-8 číslic)"
                        value={newPin}
                        onChange={e => setNewPin(e.target.value.replace(/\D/g, '').slice(0, 8))}
                        required
                        style={inputStyle}
                    />
                    <input
                        type="password"
                        inputMode="numeric"
                        placeholder="Potvrďte nový PIN"
                        value={confirmPin}
                        onChange={e => setConfirmPin(e.target.value.replace(/\D/g, '').slice(0, 8))}
                        required
                        style={inputStyle}
                    />

                    {error && (
                        <p style={{ fontSize: '13px', color: '#EF4444', margin: 0, textAlign: 'center' }}>
                            {error}
                        </p>
                    )}

                    <button
                        type="submit"
                        disabled={loading || newPin.length < 4}
                        style={{
                            width: '100%',
                            padding: '12px 16px',
                            borderRadius: '10px',
                            border: 'none',
                            background: 'var(--brand)',
                            color: '#fff',
                            fontSize: '14px',
                            fontWeight: 600,
                            cursor: loading || newPin.length < 4 ? 'not-allowed' : 'pointer',
                            opacity: loading || newPin.length < 4 ? 0.5 : 1,
                            marginTop: '4px',
                        }}
                    >
                        {loading ? 'Ukládám...' : 'Uložit PIN'}
                    </button>
                </form>
            </div>
        </div>
    );
}
